import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasArticles)?_c(VContainer,{staticClass:"pa-0"},[_c('Posts')],1):_c('NoData',{attrs:{"hasItems":false,"isNotFoundPage":false,"typeData":'article'}})}
var staticRenderFns = []

export { render, staticRenderFns }